import React, { useState, useEffect } from "react";
import style from "./index.scss";

const AnalogClock = () => {
  const [darkMode, toggleMode] = useState(false);
  useEffect(() => {
    const deg = 6;
    const hr = document.querySelector("#hr");
    const mn = document.querySelector("#mn");
    const sc = document.querySelector("#sc");

    setInterval(() => {
      let day = new Date();
      let hh = day.getHours() * 30;
      let mm = day.getMinutes() * deg;
      let ss = day.getSeconds() * deg;

      hr.style.transform = `rotateZ(${hh + mm / 12}deg)`;
      mn.style.transform = `rotateZ(${mm}deg)`;
      sc.style.transform = `rotateZ(${ss}deg)`;
    });
  }, []);

  return (
    <div className={`${style["clock-holder"]} ${darkMode ? " light" : ""}`}>
      <div className={style["clock"]}>
        <div className={style["hour"]}>
          <div className={style["hr"]} id="hr"></div>
        </div>
        <div className={style["min"]}>
          <div className={style["mn"]} id="mn"></div>
        </div>
        <div className={style["sec"]}>
          <div className={style["sc"]} id="sc"></div>
        </div>
      </div>
      <div
        className={style["toggle-btn"]}
        onClick={() => toggleMode(!darkMode)}
      ></div>
    </div>
  );
};

export default AnalogClock;
